import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  modalMsg: { type: "", msg: "" },
  walletAddressAddPending: false,
  walletAddressAddSuccess: false,
  walletAddressAddFailure: false,
  swapInfo: {},
  swapInfoPending: false,
  swapInfoSuccess: false,
  swapInfoFailure: false,
  swapMupToAmoResult: {},
  swapMupToAmoResultCode: "",
  swapMupToAmoPending: false,
  swapMupToAmoSuccess: false,
  swapMupToAmoFailure: false,
  amoHistory: {},
  amoHistoryPending: false,
  amoHistorySuccess: false,
  amoHistoryFailure: false,
  temporaryWalletAddr: {},
  temporaryWalletAddrPending: false,
  temporaryWalletAddrSuccess: false,
  temporaryWalletAddrFailure: false,
  swapConfirmPending: false,
  swapConfirmSuccess: false,
  swapConfirmFailure: false,
  swapConfirmResult: {},
  swapAmoToMupResult: {},
  swapAmoToMupPending: false,
  swapAmoToMupSuccess: false,
  swapAmoToMupFailure: false,
};
const amoSlice = createSlice({
  name: "amo",
  initialState,
  reducers: {
    showMsg: (state, payload) => {
      state.modalMsg = {
        msg: payload.payload.msg,
        type: payload.payload.type,
      };
    },

    // **아모 부리토 월렛주소 등록 **
    fetchWalletAddressAdd: (state) => {
      state.walletAddressAddPending = true;
      state.walletAddressAddSuccess = false;
      state.walletAddressAddFailure = false;
      state.modalMsg = {
        msg: "",
        type: "",
      };
    },
    fetchWalletAddressAddSuccess: (state, { payload }) => {
      state.walletAddressAddPending = false;
      state.walletAddressAddSuccess = true;
      state.walletAddressAddFailure = false;
      state.modalMsg = {
        msg: "지갑 주소 등록을 성공하였습니다.",
        type: "",
      };
    },
    fetchWalletAddressAddFailure: (state, { payload }) => {
      state.walletAddressAddPending = false;
      state.walletAddressAddSuccess = false;
      state.walletAddressAddFailure = true;
      state.modalMsg = {
        msg: payload.response.data.message,
        type: "",
      };
    },

    // **아모 교환 페이지 정보**
    fetchSwapInfo: (state) => {
      state.swapInfoPending = true;
      state.swapInfoSuccess = false;
      state.swapInfoFailure = false;
    },
    fetchSwapInfoSuccess: (state, { payload }) => {
      state.swapInfoPending = false;
      state.swapInfoSuccess = true;
      state.swapInfoFailure = false;
      state.swapInfo = payload.data.params;
    },
    fetchSwapInfoFailure: (state, { payload }) => {
      state.swapInfoPending = false;
      state.swapInfoSuccess = false;
      state.swapInfoFailure = true;
    },

    // **뮤포인트 -> 아모코인 교환**
    fetchSwapMupToAmo: (state) => {
      state.swapMupToAmoPending = true;
      state.swapMupToAmoSuccess = false;
      state.swapMupToAmoFailure = false;
    },
    fetchSwapMupToAmoSuccess: (state, { payload }) => {
      state.swapMupToAmoPending = false;
      state.swapMupToAmoSuccess = true;
      state.swapMupToAmoFailure = false;
      state.swapMupToAmoResult = payload.data.params;
      state.swapMupToAmoResultCode = payload.data.code;
    },
    fetchSwapMupToAmoFailure: (state, { payload }) => {
      state.swapMupToAmoPending = false;
      state.swapMupToAmoSuccess = false;
      state.swapMupToAmoFailure = true;
    },

    // **아모 거래내역**
    fetchAmoHistory: (state) => {
      state.amoHistoryPending = true;
      state.amoHistorySuccess = false;
      state.amoHistoryFailure = false;
    },
    fetchAmoHistorySuccess: (state, { payload }) => {
      state.amoHistoryPending = false;
      state.amoHistorySuccess = true;
      state.amoHistoryFailure = false;
      state.amoHistory = payload.data.params;
    },
    fetchAmoHistoryFailure: (state, { payload }) => {
      state.amoHistoryPending = false;
      state.amoHistorySuccess = false;
      state.amoHistoryFailure = true;
    },

    // **아모 임시 입금 주소**
    fetchTemporaryWalletAddr: (state) => {
      state.temporaryWalletAddrPending = true;
      state.temporaryWalletAddrSuccess = false;
      state.temporaryWalletAddrFailure = false;
    },
    fetchTemporaryWalletAddrSuccess: (state, { payload }) => {
      state.temporaryWalletAddrPending = false;
      state.temporaryWalletAddrSuccess = true;
      state.temporaryWalletAddrFailure = false;
      state.temporaryWalletAddr = payload.data.params;
    },
    fetchTemporaryWalletAddrFailure: (state, { payload }) => {
      state.temporaryWalletAddrPending = false;
      state.temporaryWalletAddrSuccess = false;
      state.temporaryWalletAddrFailure = true;
    },

    // **아모코인 일회용주소 입금 확인하기**
    fetchSwapConfirm: (state) => {
      state.swapConfirmPending = true;
      state.swapConfirmSuccess = false;
      state.swapConfirmFailure = false;
    },
    fetchSwapConfirmSuccess: (state, { payload }) => {
      state.swapConfirmPending = false;
      state.swapConfirmSuccess = true;
      state.swapConfirmFailure = false;
      state.swapConfirmResult = payload.data.params;
    },
    fetchSwapConfirmFailure: (state, { payload }) => {
      state.swapConfirmPending = false;
      state.swapConfirmSuccess = false;
      state.swapConfirmFailure = true;
    },

    // **아모코인 -> 뮤포인트 교환**
    fetchSwapAmoToMup: (state) => {
      state.swapAmoToMupPending = true;
      state.swapAmoToMupSuccess = false;
      state.swapAmoToMupFailure = false;
    },
    fetchSwapAmoToMupSuccess: (state, { payload }) => {
      state.swapAmoToMupPending = false;
      state.swapAmoToMupSuccess = true;
      state.swapAmoToMupFailure = false;
      state.swapAmoToMupResult = payload.data.params;
    },
    fetchSwapAmoToMupFailure: (state, { payload }) => {
      state.swapAmoToMupPending = false;
      state.swapAmoToMupSuccess = false;
      state.swapAmoToMupFailure = true;
    },
  },
});

// 정의한 액션과 리듀서를 export한다.
export const amoActions = amoSlice.actions;
export default amoSlice;
